/**
 * This class represents the single Seat object.
 * It describes both the geometry (x,y,size) of the seat and the data behind it (attributes, section, row...)
 * @class DataSeat */
export default class DataSeat {
  constructor (opts) {
    opts = opts || {};

    /**
     * The seat id is a combination of the section, block, row and seat.
     * usually it looks like this:
     *
     * `"G-HS-10-12"`
     *
     * Section G
     * Block HS
     * Row 10
     * Seat 12
     * @type {String} */
    this.id = opts.id;

    /**
     * This flag comes from the Availability feed associated with this Seat.
     * See @class Availability for more info
     * @type {Boolean} */
    this.available = opts.available;

    /**
     * This array comes from the Availability feed associated with this Seat.
     * See @class Availability for more info
     * @type {Array<String>} */
    this.attributes = opts.attributes;

    /**
     * This is a spatial point where your seat will be anchored
     * @type {DataPoint} */
    this.position = opts.position;

    /**
     * The size of the seat will determine the radius of the seat element
     * if `opts.size = 10`
     * ```
     * <circle cx="100" cy="100" r="10" />
     * ```
     * @type {Number} */
    this.size = opts.size;

    /**
     * Section code
     * `"TF-104"`
     * @type {String} */
    this.section = opts.section;

    /**
     * Row code
     * `"10"`
     * @type {String} */
    this.row = opts.row;

    /**
     * Seat code
     * `"12"`
     * @type {String} */
    this.seat = opts.seat;

    /**
     * Price Level
     * @type {String|Number} */
    this.priceLevel = opts.priceLevel;

    /**
     * Blocking code
     * @type {Number} */
    this.blockingCode = opts.blockingCode;
  }
}



// WEBPACK FOOTER //
// ./frontend/react/sim/schemas/Seat.js